import { SET_PROCESOS } from './../mutation-types';
const procesos = {
  state: {
    items: []
  },
  mutations: {
    [SET_PROCESOS](state, items) {
      state.items = items;
    }
  },
  actions: {
    setProcesos({ commit }, items) {
      commit(SET_PROCESOS, items);
    }
  }
};

export default procesos;
